import { render } from "./RoleCard.vue?vue&type=template&id=25395ff0&scoped=true&ts=true"
import script from "./ts/roleCardHelper.ts?vue&type=script&lang=ts"
export * from "./ts/roleCardHelper.ts?vue&type=script&lang=ts"

import "./RoleCard.vue?vue&type=style&index=0&id=25395ff0&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25395ff0"]])

export default __exports__